import React from "react";

const Xml = props => (
  <svg viewBox="0 0 46 58" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M45.5 39V13.978c0-.766-.092-1.333-.55-1.792L33.313.55A1.891 1.891 0 0 0 31.985 0H2.963C1.777 0 .5.916.5 2.926V39h45zm-14-35.609c0-.458.553-.687.877-.363l10.095 10.095a.513.513 0 0 1-.363.877H31.5V3.391zm-3.707 15.316a.999.999 0 1 1 1.414-1.414l6 6a.999.999 0 0 1 0 1.414l-6 6a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L33.086 24l-5.293-5.293zm-9.236 12.96l6-17a1 1 0 1 1 1.886.666l-6 17a1 1 0 1 1-1.886-.666zm-8.764-8.374l6-6a.999.999 0 1 1 1.414 1.414L11.914 24l5.293 5.293a.999.999 0 1 1-1.414 1.414l-6-6a.999.999 0 0 1 0-1.414zM.5 41v15c0 1.009 1.22 2 2.463 2h40.074c1.243 0 2.463-.991 2.463-2V41H.5zm16.436 13h-1.9l-1.6-3.801h-.137L11.576 54h-1.9l2.557-4.895-2.721-5.182h1.873l1.777 4.102h.137l1.928-4.102H17.1l-2.721 5.182L16.936 54zm11.73 0h-1.668v-6.932l-2.256 5.605h-1.449l-2.27-5.605V54h-1.668V43.924h1.668l2.994 6.891 2.98-6.891h1.668V54h.001zm8.832 0h-6.303V43.924h1.668v8.832h4.635V54z" />
    </g>
  </svg>
);

export default Xml;




// WEBPACK FOOTER //
// src/resources/svg/FileXML.js